import { useCallback, useEffect, useState } from 'react';
import { getDashboardSummary } from '../services/dashboardService';

function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function toISODate(date) {
  return date.toISOString().slice(0, 10);
}

export function useDashboardData() {
  const now = new Date();
  const [startDate, setStartDate] = useState(toISODate(startOfMonth(now)));
  const [endDate, setEndDate] = useState(toISODate(endOfMonth(now)));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const summary = await getDashboardSummary(startDate, endDate);
      setData(summary);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    refetch: fetchData,
  };
}
